import React, { Component } from 'react';

export default class WideCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { image, alt, heading, problemText, solutionText } = this.props;

    return (
      <div className="careers-page__wide-card">
        <img src={image} alt={alt} />
        <div className="wide-card__content">
          <h3>{heading}</h3>
          <p>
            <b>Problem: </b>
            {problemText}
          </p>
          <p>
            <b>Solution: </b>
            {solutionText}
          </p>
        </div>
      </div>
    );
  }
}
